import { OptionsEditor } from "./OptionsEditor"
import { PlaceholderInspector } from "./PlaceholderInspector"
import type { ControlInspector } from "./types"

export const dropdownMulti: ControlInspector<"dropdownMulti"> = {
  Inspector: ({ field, onEdit }) => (
    <>
      <OptionsEditor
        eyebrow="Menu options"
        legend="Dropdown choices"
        options={field.options}
        onChange={(options) => onEdit({ options })}
      />
      <PlaceholderInspector placeholder={field.placeholder} onEdit={onEdit} />
    </>
  ),
}
